import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Col, Row } from "react-bootstrap";
import Textarea from '../components/inputTxtarea/Textarea';
import UploadIMG from "../components/uploads/UploadIMG";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { createAndUpdateClub, getDataClub } from "../api/ourservice_api";
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function ClubLounge() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [txtEnDescValue, setTxtEnDescValue] = useState('');
    const [txtThDescValue, setTxtThDescValue] = useState('');
    const [txtEnHelpDescValue, setTxtEnHelpDescValue] = useState('');
    const [txtThHelpDescValue, setTxtThHelpDescValue] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleChangeInput500 = async (event,inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 500) {
            const result = await alertOverLimit(); 
                if (result.isConfirmed) {
                    const trimmedValue = inputValue.substring(0, 500); // Trim to 50 characters
                    //const lastSpaceIndex = trimmedValue.lastIndexOf(" ");
                    const finalValue = trimmedValue.substring(0); // Trim at last space
                    if (inpName=='enDesc') {                    
                        setTxtEnDescValue(finalValue);
                    }
                    else if (inpName == 'thDesc') {
                        setTxtThDescValue(finalValue);
                    }
                    else if (inpName == 'enHelpDesc') {
                        setTxtEnHelpDescValue(finalValue);
                    }
                    else if (inpName == 'thHelpDesc') {
                        setTxtThHelpDescValue(finalValue);
                    }
                    
                }
                else {
                    if (inpName == 'enDesc') {                    
                        setTxtEnDescValue(inputValue);
                    }
                    else if (inpName == 'thDesc') {
                        setTxtThDescValue(inputValue);
                    }
                    else if (inpName == 'enHelpDesc') {
                        setTxtEnHelpDescValue(inputValue);
                    }
                    else if (inpName == 'thHelpDesc') {
                        setTxtThHelpDescValue(inputValue);
                    }
                    
                }
        }
        else {
            if (inpName == 'enDesc') {                    
                setTxtEnDescValue(inputValue);
            }
            else if (inpName == 'thDesc') {
                setTxtThDescValue(inputValue);
            }
            else if (inpName == 'enHelpDesc') {
                setTxtEnHelpDescValue(inputValue);
            }
            else if (inpName == 'thHelpDesc') {
                setTxtThHelpDescValue(inputValue);
            }
            
        }
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
            const formatedBodyToServer = {
                club_description_en: txtEnDescValue,
                club_description_th: txtThDescValue,
                diamond_description_en: txtEnHelpDescValue,
                diamond_description_th: txtThHelpDescValue,
                diamond_image: images1 ?? null,
            }
            if (
                !formatedBodyToServer.club_description_en ||
                !formatedBodyToServer.club_description_th ||
                !formatedBodyToServer.diamond_description_en ||
                !formatedBodyToServer.diamond_description_th ||
                !formatedBodyToServer.diamond_image.length > 0
            ) {
                await alertValidate();
            } else {
                const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateClub(formatedBodyToServer);
                        setLoading(false)
                          if (response.status == "success") {
                            const result = await alertSaved();
                              if (result.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
        
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
                navigateToBack("/infoClubLounge");
            }
            else { }
    };

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const result = await getDataClub()

            let dataPreview = result.data;
            setEditId(dataPreview._id)
            setTxtEnDescValue(dataPreview.club_description_en)
            setTxtThDescValue(dataPreview.club_description_th)
            setTxtEnHelpDescValue(dataPreview.diamond_description_en)
            setTxtThHelpDescValue(dataPreview.diamond_description_th)

            const imgsDiamond = dataPreview.diamond_image;
            if (imgsDiamond && Array.isArray(imgsDiamond)) {
                const images = await Promise.all(imgsDiamond.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
            
        } catch (error) {
            console.log('found error', error)
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])

  return (
    <>
        <style>
            {`
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"OUR SERVICE & PRIVILEGE"} />
        <Menu
            parentmenu={"infoOurService"}
            activemenu={"infoClubLounge"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-service.png" className="ic-user01 me-2" alt="" />
                                OUR SERVICE & PRIVILEGE<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> ASP CLUB LOUNGE
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                    ASP  Club Lounge
                                    </font>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnDescValue}
                                        onChange={(newData) => {
                                            setTxtEnDescValue(newData);
                                        }}
                                        placeholder="Description *"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThDescValue}
                                        onChange={(newData) => {
                                            setTxtThDescValue(newData);
                                        }}
                                        placeholder="คำอธิบาย *"
                                    />
                                </Col>
                            </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                ASP Diamond Privilege Card
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnHelpDescValue}
                                    onChange={(newData) => {
                                        setTxtEnHelpDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThHelpDescValue}
                                    onChange={(newData) => {
                                        setTxtThHelpDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default ClubLounge